/*
 * @Author: Dzy
 * @Date: 2022-07-18 11:13:54
 * @LastEditors: Dzy
 * @LastEditTime: 2022-11-07 15:26:24
 * @Description: 登录鉴权功能模块
 */
import { login } from '@/api/auth.js'
import { checkResult } from '@/utils/tools'

import { useRequest } from 'vue-request'
import { ref } from 'vue'
/**
 * 登录模块
 * @param {*} tokenStore.update_token token存储（使用pinia存储）
 * @returns
 */

export default (tokenStore) => {
  const loginLoading = ref(false)
  const { data: result, runAsync, } = useRequest(login)
  const formParams = ref({
    accountNum: '',
    password: '',
    code: '',
    randomStr: ''
  })
  const doLogin = async (captcha) => {
    const payload = { ...formParams.value, randomStr: captcha.randomStr }

    await runAsync(payload)

    if (checkResult(result.value)) {
      tokenStore.update_token(result.value.data)
    } else {
      throw new Error(result.value.msg)
    }
  }
  const doLoginToken = async (data) => {
    let access_token = data.token.split(' ')[1]
    let token_type = data.token.split(' ')[0]
    tokenStore.update_token({ access_token, token_type })
  }

  return {
    formParams,
    loginLoading,
    doLoginToken,
    doLogin
  }
}
